const {enabled}=require('./transition.js');
const cards=[...document.querySelectorAll('.one-services--panels .one-services__item')];
let frame=0,active=null,x=0,y=0;
const paint=()=>{
 frame=0;
 if(!active)return;
 active.style.setProperty('--service-pointer-x',String(x));
 active.style.setProperty('--service-pointer-y',String(y));
};
const reset=()=>{
 cancelAnimationFrame(frame);frame=0;
 cards.forEach(card=>['--service-pointer-x','--service-pointer-y'].forEach(name=>card.style.removeProperty(name)));
 active=null;
};
cards.forEach(card=>{
 card.querySelectorAll('.one-services__panel-art :is(path,rect,circle,line,polyline,polygon):not([stroke-dasharray])').forEach(shape=>{
  try {
   const length=shape.getTotalLength?.();
   if(Number.isFinite(length)&&length>0){shape.style.setProperty('--stroke-length',`${length.toFixed(2)}px`);shape.setAttribute('data-draw-stroke','');}
  } catch(error) { /* Geometry remains visible when length calculation is unavailable. */ }
 });
 card.addEventListener('pointermove',event=>{
  if(event.pointerType!=='mouse'||!enabled())return;
  const rect=card.getBoundingClientRect();
  active=card;x=Math.max(-.5,Math.min(.5,(event.clientX-rect.left)/rect.width-.5));y=Math.max(-.5,Math.min(.5,(event.clientY-rect.top)/rect.height-.5));
  if(!frame)frame=requestAnimationFrame(paint);
 });
 card.addEventListener('pointerleave',reset);
});
addEventListener('onestep:motion',reset);
